// FrontEnd.jsx
import SkillCard from './SkillCard';

const FrontEnd = () => {
  const frontendSkills = [
    { name: 'TypeScript', icon: 'bx bxl-typescript' },
    { name: 'JavaScript', icon: 'bx bxl-javascript' },
    { name: 'React', icon: 'bx bxl-react' },
    { name: 'Next.js', icon: 'devicon-nextjs-plain' },
    { name: 'HTML5', icon: 'bx bxl-html5' },
    { name: 'CSS3', icon: 'bx bxl-css3' },
    { name: 'Tailwind CSS', icon: 'bx bxl-tailwind-css' },
  ];

  return (
    <div className="skills__content">
      <div className="skills__content-header">
        <h3 className="skills__title">Frontend Development</h3>
        <p className="skills__description">Modern web applications with TypeScript & React</p>
      </div>
      <div className="skills__grid">
        {frontendSkills.map((skill, index) => (
          <SkillCard
            key={index}
            name={skill.name}
            icon={skill.icon}

          />
        ))}
      </div>
    </div>
  );
};

export default FrontEnd;